const ModalStyle = {
	position: 'absolute',
	top: '50%',
	left: '50%',
	transform: 'translate(-50%, -50%)',
	maxHeight: '95%',
	overflowY: 'auto',
	bgcolor: 'white',
	border: '1px solid transparent',
	boxShadow: 24,
    px: 3,
    py: 3
};

export default ModalStyle;
